'use client';

import type { PropsWithChildren } from 'react';
import join from 'url-join';

import { getCWEA, getENV } from '../../utils';
import { CopilotKit, useChatThread } from '../runtime';
import { chatHeaders } from '../utils';

export function ChatbotProvider({ children }: PropsWithChildren) {
    const { threadId } = useChatThread();

    return (
        <CopilotKit
            headers={chatHeaders}
            runtimeUrl={join(getCWEA(), 'chat/runtime')}
            enableInspector={getENV('NEXT_PUBLIC_COPILOTKIT_DEVTOOLS')}
            useSingleEndpoint={false}
            threadId={threadId}
        >
            {children}
        </CopilotKit>
    );
}
